const COLLECTION = "reports";

const populateSnapshots = (snapshots) => {
  const docs = [];
  snapshots.forEach((snap) => {
    docs.push(extractSnapshotData(snap));
  });
  return docs;
};

const extractSnapshotData = (snap) => {
  return {
    id: snap.id,
    ...snap.data()
  };
};

function ReportsMixin() {
  return {
    async createReport({ report }) {
      const ref = await this.collection(COLLECTION).add(report);
      const reportData = {
        id: ref.id,
        ...report
      };
      return reportData;
    },

    async updateReport({ id, data }) {
      return await this.collection(COLLECTION).doc(id).set(data, { merge: true });
    },

    async cancelReportsByCampaignId({ campaingId }) {
      return await this.collection(COLLECTION).where("campaignId", "==", campaingId).delete();
    },

    async getReportsByCampaignId({ campaignId }) {
      return await this.collection(COLLECTION)
        .where("campaignId", "==", campaignId)
        .get()
        .then((querySnapshot) => populateSnapshots(querySnapshot));
    },

    async getActiveReportsByCampaignId({ campaignId }) {
      return await this.collection(COLLECTION)
        .where("campaignId", "==", campaignId)
        .where("status", "==", "ON_QUEUE")
        .get()
        .then((querySnapshot) => populateSnapshots(querySnapshot));
    },

    async getActiveReports() {
      return await this.collection(COLLECTION)
        .where("status", "==", "ON_QUEUE")
        .get()
        .then((querySnapshot) => populateSnapshots(querySnapshot));
    },

    async getFinishedReports() {
      return await this.collection(COLLECTION)
        .where("status", "==", "FINISHED")
        .get()
        .then((querySnapshot) => populateSnapshots(querySnapshot));
    }
  };
}

module.exports = ReportsMixin;
